<template>
  <!-- CONTENT NOT STICKY, OVERFLOWED IF NEEDED -->
  <div class="TabPanelShare py-5 px-6 space-y-3 overflow-y-auto flex-1 h-0">
    <slot name="top"></slot>

    <div v-if="enableLinkShare">
      <div>
        <div 
          class="flex flex-wrap items-center space-y-3 py-3" 
          v-aw-driver-element="'AsideModalShareTabs'"
        >
          <nav 
            class="-mb-px flex flex-1" 
            aria-label="Tabs"
          >
            <tab-panel-pill
              v-for="(item, index) in items"
              :key="index"
              @click.stop.prevent="changeModel(item.type)"
              :active="item.type === $formValues['frm-sharingForm-sharingForm-sharing_type']"
              :icon="item.icon"
              :text="$t(item.text)"
              class="pill__Tab-white"
            />
          </nav>
        </div>
      </div>
    </div>

    <slot v-bind="{ enableLinkShare }"></slot>
  </div>
  <!-- STICKY FOOTER - SUBMIT BUTTONS ALMOST -->
  <div class="flex-shrink-0 p-5 border-t border-gray-400">
    <slot name="bottom" v-bind="{ copyLink, success }"></slot>
  </div>
</template>

<script>
import { useClipboard } from '@vueuse/core'
import { ShareApi } from '../../test-api/index.ts'
const shareApi = new ShareApi({}, '/api/v2')
import { shareLink, shareLinkModalDisplayed } from './ShareFormContext'
import handleApiError from '../../utils/handleApiError'

export default {
  props: {
    enableLinkShare: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [
        {
          type: 'email',
          icon: 'email',
          text: 'E-mail'
        },
        {
          type: 'link',
          icon: 'link',
          text: 'Link'
        }
      ]
    }
  },
  methods: {
    changeModel(type) {
      this.$formValues['frm-sharingForm-sharingForm-sharing_type:change'] = type

      // pracovni verze
      this.$nextTick(async () => {
        if (type === 'link') {
          const createLinkResponse = await handleApiError(() => shareApi.shareCreateLink())
          this.$store.dispatch('nette/updateControl', {
            controlName: 'frm-sharingForm-sharingForm-embed_code',
            data: createLinkResponse.data.link,
            key: 'val'
          })
          this.$store.dispatch('nette/updateControl', {
            controlName: 'frm-sharingForm-sharingForm-hash',
            data: createLinkResponse.data.hash,
            key: 'val'
          })
        }
      })
    },
    copyLink() {
      if (
        this.$formValues['frm-sharingForm-sharingForm-sharing_type'] === 'link'
      ) {
        const clipboard = useClipboard()
        clipboard.copy(
          this.$formValues['frm-sharingForm-sharingForm-embed_code']
        )

        shareLink.value = this.$formValues['frm-sharingForm-sharingForm-embed_code']
      }
    },
    success() {
      if (this.$formValues['frm-sharingForm-sharingForm-sharing_type'] === 'link') {
        shareLinkModalDisplayed.value = true
      }
    }
  },
  mounted() {
    shareLinkModalDisplayed.value = false
  }
}
</script>

<style lang="scss">
.TabPanel--Sticky {
  position: sticky;
  top: 90px;
  padding-top: 12px;
  z-index: 15;
  background: #fff;
}
</style>
